<script>
import { onMount, onDestroy } from 'svelte'
import { createEventDispatcher } from 'svelte';
import { runSketch, createCanvas } from './run_processing.js';
import { js_beautify} from "./beautify.js";
import runCodeStore from "./runCodeStore.js";
import {classSystemCode, classJunitCode} from "./runcode_files.js";
import { slide, fade } from 'svelte/transition';

const dispatch = createEventDispatcher();

// export let processing = false;
export let task;
export let fromAdmin = false;
export let type;
export let taskDone;
export let taskCheck;
export let firstContentChanged = false;
export let processingcode;
export let javacodeFileMain;

let completionItemProvider;

$: hidden = type == "processing" ? '' : 'hidden';
// $: checkCodehidden = (type == "java" && !taskDone) ? '' : 'hidden';
$: checkCodehidden = (type == "java" && !taskDone && !taskCheck) ? '' : 'hidden';
$: checkProcessingCodehidden = (type == "processing" && !taskDone && !taskCheck) ? '' : 'hidden';
// $: console.log('taskDone ' + taskDone + " " + type);

let consoleText = "";

// $: {
//   $runCodeStore;
//   var textarea = document.getElementById('runCodeOutput');
//   if (textarea) textarea.scrollTop = textarea.scrollHeight;
// }

let runCodeOutput = "";
let runCodeInputFromUser = "";
// $: runCodeOutputAll = runCodeOutput + "" + $runCodeStore;
$: runCodeOutputAll = $runCodeStore;

let startMessage = {
    files: [{
        name: "Main",
        content: ""
    }, {
        name: "System",
        content: classSystemCode
    }],
    junit: classJunitCode,
    type: "code",
    startClass: "Main"
}

// START MONACO MULTIFILES

let files = [];
//   {name: "Main.java", text: 'const tab = 1;', model: null, active: true},
//   {name: "TestCode.java", text: 'const tab = 2;', model: null, active: false},
//   {name: "Animal.java", text: 'const tab = 3;', model: null, active: false},
//   {name: "Animal1.java", text: 'const tab = 4;', model: null, active: false},
//   {name: "Animal2.java", text: 'const tab = 5;', model: null, active: false},
//   {name: "Animal3.java", text: 'const tab = 6;', model: null, active: false},
//   {name: "Animal4.java", text: 'const tab = 7;', model: null, active: false},
//   {name: "Animal5.java", text: 'const tab = 7;', model: null, active: false},
//   {name: "Animal6.java", text: 'const tab = 7;', model: null, active: false},
// ];

if (fromAdmin) {
  // console.log('javacodeFileMain: ' + javacodeFileMain)
  files = [
    {name: "Main.java", text: javacodeFileMain, model: null, active: true},
    {name: "TestCode.java", text: task.junit, model: null, active: false},    
  ]
}

// let currentFile;

function changeTab(fileName) {
  // console.log('fn: ' +fileName);
  let file = files.find(f=>f.name == fileName);
  if (!file) return;
  if (file.active) return;

  // создаем модель редактора (если ее нет и есть текст) или берем текущую
  // const model = !file.model && file.text
  //   // ? window.editor.createModel(file.text, 'java')
  //   ? monaco.editor.createModel(file.text, 'java')
  //   : file.model;  

    let model;
    if (!file.model && file.text) {
      model = monaco.editor.createModel(file.text, 'java')
      model.updateOptions({
        language: "java",
        lineNumbers: "on",
        roundedSelection: true,
        scrollBeyondLastLine: false,
        readOnly: false,
        minimap: { enabled: false },
        theme: "vs-dark"
      });
      file.model = model;
    } else {
      model = file.model;  
    }

  // активируем новую вкладку и сохраняем модель предыдущей активной вкладки
  files = files.map(tab => ({
    ...tab, 
    model: tab.active ? window.editor.getModel() : tab.model,
    active: tab.name == fileName
  }));
  files = [...files];
  // console.warn(files);

  // важно удалять виджет, иначе cannot read property style of null будет
  // window.editor.removeOverlayWidget(overlayWidget);    
  // window.editor.removeOverlayWidget(checkCodeOverlayWidget);      

  // обновляем модель редактора
  window.editor.setModel(model);    
  // monaco.editor.setModel(model); 
  
  // window.editor.addOverlayWidget(overlayWidget);    
  // window.editor.addOverlayWidget(checkCodeOverlayWidget);      
  // window.editor.layoutOverlayWidget(overlayWidget);  
  // window.editor.layoutOverlayWidget(checkCodeOverlayWidget);  

  //file['active'] = true;
  // currentFile = file;
  // var currentState = editor.saveViewState();
  // var currentModel = editor.getModel();

  // editor.setModel(data[desiredModelId].model);
  // editor.restoreViewState(data[desiredModelId].state);
  // editor.focus();
}

function addNewTab() { // работает с ошибками
  let fileName = "Undefined";
  if (files.find(f=>f.name == fileName + ".java")) fileName += Math.floor(Math.random() * 10000);
  fileName += ".java";

  // files = files.map(tab => ({
  //   ...tab, 
  //   active: false
  // }));

  let file = {name: fileName, text: '', model: null, active: false};
  files = [...files, file];
  changeTab(fileName);
  // currentFile = file;
}

// END MONACO MULTIFILES

function run() {
  window.editor.getAction('editor.action.formatDocument').run()
  .then(() => {
    window.isCodeRunStarted = true; // иначе Монако перегружается, реагируя на изменение кода
    // startMessage.files[0].content = window.editor.getValue();
    startMessage.files[0].content = fromAdmin ? files[0].model.getValue() : window.editor.getValue();
    runCodeStore.runCode(JSON.stringify(startMessage));
  });
}

function send() {
    let message = {
        files: [{
            name: "",
            content: ""
        }],
        junit: "",
        type: "message",
        startClass: consoleText
    }
    runCodeStore.sendMessage(JSON.stringify(message));
    consoleText = "";
}

const handleKeyupSend = () => {
		if (event.code == 'Enter') {
			// event.preventDefault()
      // let value = event.target.value;
      send();
			return false;
		}
}

const textAreaHandleKeyupSend = (event) => {
  event.preventDefault();
  runCodeInputFromUser += event.char;
  // console.log(event.char);
  // runCodeStore.sendChar(event.char);
  if (event.code == 'Enter') {
    send();
    return false;  
  }
}

onMount(mountEditor);

onDestroy(() => {  
  bodyUnfreezeScroll();
  document.removeEventListener('mousemove', mouseMoveListener, false);
  if (window.editor) {
    window.editor.dispose();
    const model = window.editor.getModel();
    if (model) model.dispose();

    if (fromAdmin) {
      files.forEach((f) => {
        f.model && f.model.dispose();
      });
    }
  }
  completionItemProvider && completionItemProvider.dispose();
});

let mouseMoveListener = function (e) {
    let elem = document.getElementById('sketch');
    let xClick = Math.round(e.pageX - jqOffset(elem).left) - 4;
    let yClick = Math.round(e.pageY - jqOffset(elem).top) - 4;
    if (xClick >= 0 && xClick <= elem.width && yClick >= 0 && yClick <= elem.height) {
      if (!window.isErrorInSketch) document.getElementById("mouseCoords").innerHTML = '(' + xClick + ', ' + yClick + ')';
    }    
};

let jqOffset = function( elem ) {
    var docElem, win, rect, doc;
    if ( !elem ) {
        return;
    }
    rect = elem.getBoundingClientRect();
    if ( rect.width || rect.height || elem.getClientRects().length ) {
        win = elem.ownerDocument.defaultView;
        //docElem = doc.documentElement;
        return {
            top: rect.top + win.pageYOffset,// - docElem.clientTop,
            left: rect.left + win.pageXOffset// - docElem.clientLeft
        };
    }
}

//   $("#sketch-container").mousemove(function (e) {
//     var xClick = Math.round(e.pageX - $(this).offset().left);
//     var yClick = Math.round(e.pageY - $(this).offset().top);
//     if (xClick <= document.getElementById('sketch').width && yClick >= 0) {
//       !window.isErrorInSketch && $('#mouseCoords').html('(' + xClick + ', ' + yClick + ')');
//     }
//   });
    // document.getElementById("mouseCoords").innerHTML = e.toString();



  function mountEditor() {
    bodyFreezeScroll();    

require.config({ paths: { 'vs': 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.17.1/min/vs' } });
    window.MonacoEnvironment = {
      getWorkerUrl: function (workerId, label) {
        return `data:text/javascript;charset=utf-8,${encodeURIComponent(`
          self.MonacoEnvironment = {
            baseUrl: 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.17.1/min/'
          };
          importScripts('https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.17.1/min/vs/base/worker/workerMain.js');`
        )}`;
      }
    };

    require(["vs/editor/editor.main"], function () {

      function createDependencyProposals() {
        return [    
          {
            label: 'sout',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            documentation: "System.out.println();",
            insertText: 'System.out.println($0);'
            // insertText: 'System.out.println();'
            // insertText: {value: 'System.out.println(${1:element});'}
            // insertText: {value: 'System.out.println($0);'}
            // insertText: {value: 'test'}
          },
          {
            label: 'psvm',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            documentation: "psvm",
            insertText: 'public static void main(String[] args) {\n\t$0\n}'
          },
          {
            label: 'public class',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "public class",
            insertText: 'public class $0 {\n}'
          },
          {
            label: 'private',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "private",
            insertText: 'private $0;'
          },
          {
            label: 'public',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "public",
            insertText: 'public $0'
          },    
          {
            label: 'static',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "static",
            insertText: 'static $0'
          },        
          {
            label: 'String',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "String",
            insertText: 'String $0'
          },
          {
            label: 'return',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "return",
            insertText: 'return $0;'
          },
          {
            label: 'fori',
            kind: monaco.languages.CompletionItemKind.Function,
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,            
            documentation: "fori",
            insertText: 'for (int $1 = 0; $1 < $2; $1++) {\n\t$0\n}'
          }
        ];
      }


      completionItemProvider = monaco.languages.registerCompletionItemProvider('java', {
        provideCompletionItems: function(model, position) {
          // find out if we are completing a property in the 'dependencies' object.
          // var textUntilPosition = model.getValueInRange({startLineNumber: 1, startColumn: 1, endLineNumber: position.lineNumber, endColumn: position.column});
          // var match = textUntilPosition.match(/"dependencies"\s*:\s*{\s*("[^"]*"\s*:\s*"[^"]*"\s*,\s*)*("[^"]*)?$/);
          var suggestions = true ? createDependencyProposals() : [];
          return {
            suggestions: suggestions
          };
        }
      });      

      var code = "Код загружается..."

      window.editor = monaco.editor.create(document.getElementById("container"), {
        // value: task.junit,
        // value: "Код загружается...",
        // value: "size(400, 300);\n// Напомню, что можно вернуться к подсказкам :)",
        // value: "size(400, 300);\nbackground(200, 0, 200);\n// Напомню, что можно вернуться к подсказкам :)",
        language: "java",
        lineNumbers: "on",
        roundedSelection: true,
        scrollBeyondLastLine: false,
        readOnly: false,
        minimap: { enabled: false },
        // contextmenu: false, // по умолчанию true (чтобы можно было через него скопировать слово)
        // smoothScrolling: true, // default false
        theme: "vs-dark"
      });

      let model = monaco.editor.createModel(fromAdmin ? files[0].text : 'init', 'java')
      model.updateOptions({
        language: "java",
        lineNumbers: "on",
        roundedSelection: true,
        scrollBeyondLastLine: false,
        readOnly: false,
        minimap: { enabled: false },
        theme: "vs-dark"
      });    
      window.editor.setModel(model);
      if (fromAdmin) files[0].model = window.editor.getModel();

      if (processingcode) window.editor.setValue(processingcode);
      if (javacodeFileMain) window.editor.setValue(javacodeFileMain);

      notifyThatEditorLoaded();
      // if (!window.isNotMobileOS) {
      //   window.editor.updateOptions({
      //     fontSize: "16px",
      //     fontWeight: "bold",
      //     contextmenu: false
      //   });
      // }      

      monaco.editor.defineTheme('mytheme', khasangJSON);
      monaco.editor.setTheme('mytheme');

      // window.editor.addOverlayWidget(overlayWidget);    
      // window.editor.addOverlayWidget(checkCodeOverlayWidget);    

      const javaFormatProvider = {
          provideDocumentFormattingEdits(model, options, token) {
              return [{
                  text: beautifyMe(model.getValue()),
                  range: model.getFullModelRange()
              }];
          }
      };
      monaco.languages.registerDocumentFormattingEditProvider('java', javaFormatProvider);  

      function debounce(func, wait, immediate) {
        var timeout;
        return function() {
          var context = this, args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      };      

      window.editor.onDidChangeModelContent((event) => {
        firstContentChanged = true;
        if (window.isSketchIsRunning) {
          showAndRunTrottled();
        }
        if (window.isCodeRunStarted) {
          closeRunCodeButton();
        }
      });

      let showAndRunTrottled = debounce(showAndRun, 300);      
      
      function beautifyMe(code) {
        // return Beautifier.js_beautify(code, 
        // return window.js_beautify(code, 
        // return code;
        return js_beautify(code, 
        {
          "indent_size": "4",
          "indent_char": " ",
          "max_preserve_newlines": "5",
          "preserve_newlines": true,
          "keep_array_indentation": false,
          "break_chained_methods": false,
          "indent_scripts": "normal",
          "brace_style": "collapse,preserve-inline",
          "space_before_conditional": true,
          "unescape_strings": false,
          "jslint_happy": false,
          "end_with_newline": false,
          "wrap_line_length": "0",
          "indent_inner_html": false,
          "comma_first": false,
          "e4x": false,
          "indent_empty_lines": false
        }) // put formatted text here
      }
      
    });
  }

    var khasangJSON = {
      "base": "vs-dark",
      "inherit": true,
      "rules": [
        {
          "foreground": "75715e",
          "token": "comment"
        },
        {
          "foreground": "e6db74", // 6A8759 darcula green // FFC66D darcula method name
          "token": "string"
        },
        {
          "foreground": "ae81ff", // синий
          "token": "constant.numeric"
        },
        {
          "foreground": "ae81ff",
          "token": "constant.language"
        },
        {
          "foreground": "ae81ff",
          "token": "constant.character"
        },
        {
          "foreground": "ae81ff",
          "token": "constant.other"
        },
        {
          "foreground": "CC7832", // f92672 // CC7832 // BF6B30
          "token": "keyword"
        },
        {
          "foreground": "f92672",
          "token": "storage"
        },
        {
          "foreground": "66d9ef",
          "fontStyle": "italic",
          "token": "storage.type"
        },
        {
          "foreground": "a6e22e",
          "fontStyle": "underline",
          "token": "entity.name.class"
        },
        {
          "foreground": "a6e22e",
          "fontStyle": "italic underline",
          "token": "entity.other.inherited-class"
        },
        {
          "foreground": "a6e22e",
          "token": "entity.name.function"
        },
        {
          "foreground": "fd971f",
          "fontStyle": "italic",
          "token": "variable.parameter"
        },
        {
          "foreground": "f92672",
          "token": "entity.name.tag"
        },
        {
          "foreground": "a6e22e",
          "token": "entity.other.attribute-name"
        },
        {
          "foreground": "66d9ef",
          "token": "support.function"
        },
        {
          "foreground": "66d9ef",
          "token": "support.constant"
        },
        {
          "foreground": "66d9ef",
          "fontStyle": "italic",
          "token": "support.type"
        },
        {
          "foreground": "66d9ef",
          "fontStyle": "italic",
          "token": "support.class"
        },
        {
          "foreground": "f8f8f0",
          "background": "f92672",
          "token": "invalid"
        },
        {
          "foreground": "f8f8f0",
          "background": "ae81ff",
          "token": "invalid.deprecated"
        },
        {
          "foreground": "cfcfc2",
          "token": "meta.structure.dictionary.json string.quoted.double.json"
        },
        {
          "foreground": "75715e",
          "token": "meta.diff"
        },
        {
          "foreground": "75715e",
          "token": "meta.diff.header"
        },
        {
          "foreground": "f92672",
          "token": "markup.deleted"
        },
        {
          "foreground": "a6e22e",
          "token": "markup.inserted"
        },
        {
          "foreground": "e6db74",
          "token": "markup.changed"
        },
        {
          "foreground": "ae81ffa0",
          "token": "constant.numeric.line-number.find-in-files - match"
        },
        {
          "foreground": "e6db74",
          "token": "entity.name.filename.find-in-files"
        },
        {
          "foreground": "BBB529", // BBB529 BC3F3C red
          "token": "annotation.java"
        },
        {
          "foreground": "6897BB",
          "token": "number.java"
        },
        {
          "foreground": "6897BB",
          "token": "number.float.java"
        },
        {
          "foreground": "629755",
          "token": "comment.doc.java"
        },
        {
          "foreground": "CC7832",
          "token": "delimiter.java"
        },
        {
          "foreground": "CC7832",
          "token": "delimiter.curly.java"
        },
        {
          "foreground": "CC7832",
          "token": "delimiter.parenthesis.java"
        },
        {
          "foreground": "CC7832",
          "token": "delimiter.angle.java"
        },
        {
          "foreground": "CC7832",
          "token": "delimiter.square.java"
        }
        //delimiter.curly.java delimiter.angle.java delimiter.parenthesis.java delimiter.square.java CC7832
      ],
      "colors": {
        "editor.foreground": "#F8F8F2",
        "editor.background": "#272822",
        "editor.selectionBackground": "#214283", //"#49483E", // 668CDB9C
        "editor.lineHighlightBackground": "#222317", // 3E3D32
        "editorCursor.foreground": "#668CDB9C", // "#f8f8f0"
        "editorWhitespace.foreground": "#3B3A32",
        "editorIndentGuide.activeBackground": "#668CDB9C", // 9D550FB0
        "editor.selectionHighlightBorder": "#222218"
      }
    }  

function getRandomHappySmile() {
  var runCodeSmiles = ['😀','😬','😁','😂','😃','😄','😅','😆','😇','😉','😊','😋','😌','😍','😘','😗','😙','😚','😜','😝','😛','😎','😏','😳','😰','😭','😴'];
  var i = Math.floor(Math.random() * runCodeSmiles.length);
  // console.log(i + " " + runCodeSmiles[i]);
  return runCodeSmiles[i];
}

function getRandomSadSmile() {
  var runCodeSmiles = ['😐','😑','😒','😞','😟','😠','😡','😔','😕','😣','😖','😫','😩','😤','😮','😱','😨','😰','😯','😦','😧','😢','😥','😪','😓','😭','😵','😲','😷','😴','😵'];
  var i = Math.floor(Math.random() * runCodeSmiles.length);
  return runCodeSmiles[i];
}             

function closeEditor() {
  // bodyUnfreezeScroll();
  runCodeStore.close();
  if (fromAdmin) {
    dispatch('close', {
      mainCode: files[0].model ? files[0].model.getValue() : files[0].text,
      junit: files[1].model ? files[1].model.getValue() : files[1].text,
    });
  } else {
    dispatch('close', {
      text: window.editor.getValue()
    });
  }
}

function notifyThatEditorLoaded() {
  console.log('loaded monaco');
  dispatch('loaded', {
    text: 'Привет!'
  });
}

function bodyFreezeScroll() {
  var body = document.getElementsByTagName("body")[0];
  body.classList.add("modal-open");
  // var bodyWidth = body.innerWidth();
  // body.css('overflow', 'hidden');
  // body.css('marginRight', (body.css('marginRight') ? '+=' : '') + (body.innerWidth() - bodyWidth))
}

function bodyUnfreezeScroll() {
  var body = document.getElementsByTagName("body")[0];
  body.classList.remove("modal-open");
  // var bodyWidth = body.innerWidth();
  // body.css('marginRight', '-=' + (bodyWidth - body.innerWidth()))
  // body.css('overflow', 'auto');
}

function runSketchButton() {
  window.isSketchIsRunning = true;
  showAndRun();  
}

function showAndRun() {
  console.log('run ');
  document.addEventListener('mousemove', mouseMoveListener, false);
  document.getElementById("run-sketch-button").style.display = "none";
  document.getElementById("close-sketch-button").style.display = "block";
  document.getElementById("all-sketch-container").style.display = "block";
  document.getElementById("submit-sketch-to-teacher-button").style.display = "block";
  runSketch();
  // window.editor.layoutOverlayWidget(overlayWidget);
}    

function closeSketchButton() {
  console.log('close');
  document.removeEventListener('mousemove', mouseMoveListener, false);
  window.isSketchIsRunning = false;
  createCanvas();
  // window.editor.layoutOverlayWidget(overlayWidget);
  document.getElementById("run-sketch-button").style.display = "block";
  document.getElementById("close-sketch-button").style.display = "none";  
  document.getElementById("all-sketch-container").style.display = "none";  
  document.getElementById("submit-sketch-to-teacher-button").style.display = "none";  
}

function submitSketchToTeacher() {
    bodyUnfreezeScroll();
    document.getElementById("submit-sketch-to-teacher-button").innerHTML = "Сохраняю... Подождите...";  
    let codeValue = window.editor.getValue();
    let lastChar = codeValue.slice(codeValue.length - 1);
    if (lastChar != "\n") codeValue += "\n";
    dispatch('submitSketch', {
      text: codeValue
    });
}

// RUN CODE START

function closeRunCodeButton() {
  console.log('closeRunCodeButton');
  runCodeStore.close();
  window.isCodeRunStarted = false;
  // document.removeEventListener('mousemove', mouseMoveListener, false);
  // window.isSketchIsRunning = false;
  // createCanvas();
  // window.editor.layoutOverlayWidget(checkCodeOverlayWidget);
  document.getElementById("runCodeButton").style.display = "block";
  document.getElementById("close-runcode-button").style.display = "none";  
  document.getElementById("all-runcode-container").style.display = "none";  
  document.getElementById("submit-runcode-to-teacher-button").style.display = "none";  
  // document.getElementById("check-code-button").style.display = "none";  
}


function runCodeButton() {
  console.log('runCodeButton ');  
  // document.addEventListener('mousemove', mouseMoveListener, false);
  document.getElementById("runCodeButton").style.display = "none";
  document.getElementById("close-runcode-button").style.display = "block";
  document.getElementById("all-runcode-container").style.display = "block";
  document.getElementById("submit-runcode-to-teacher-button").style.display = "block";
  // document.getElementById("check-code-button").style.display = "block";
  run();
  // runSketch();  
    // bodyUnfreezeScroll();
    // document.getElementById("submit-runcode-to-teacher-button").innerHTML = "Сохраняю... Подождите...";  
    // let codeValue = window.editor.getValue();
    // let lastChar = codeValue.slice(codeValue.length - 1);
    // if (lastChar != "\n") codeValue += "\n";
    // dispatch('submitSketch', {
    //   text: codeValue
    // });
}


// PROCESSING
let overlayWidget = {
  domNode: null,
  getId: function () {
    return 'my.overlay.widget';
  },
  getDomNode: function () {
    return document.getElementById("processingWidget");
  },
  getPosition: function () {
    return { preference: 0 };//null;
  }
};

let checkCodeOverlayWidget = {
  domNode: null,
  getId: function () {
    return 'my.overlay.checkCodewidget';
  },
  getDomNode: function () {
    return document.getElementById("checkCodeWidget");
  },
  getPosition: function () {
    return { preference: 0 };//null;
  }
};

function checkCode() {
    // dispatch('checkCode', {
    //   text: window.editor.getValue() // Можно не передавать, пока никто не использует
    // });
  if (fromAdmin) {
    console.log('checkCode fromAdmin: ' + fromAdmin);
    dispatch('checkCode', {
      mainCode: files[0].model ? files[0].model.getValue() : files[0].text,
      junit: files[1].model ? files[1].model.getValue() : files[1].text,
    });
  } else {
    dispatch('checkCode', {
      text: window.editor.getValue()
    });
  }    
}
</script>

<style>
#__old_container {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 100; /* Sit on top */
    /* padding-top: 100px;  */
    /* padding: 100px; */
    left: 100px;
    right: 100px;
    top: 50px;
    bottom: 50px;
    overflow: scroll;
    /* width: 80%;  */
    /* height: 10%;  */
    /* Enable scroll if needed */
    /* overflow: auto;  */
    /* height: 100%; */
    /* overflow: hidden; */
}

#container {
  height: 100%;
  z-index: 100; /* Sit on top */
}

  .modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 2; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; 
    /* overflow:  ; */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  button.playground {
    /* display: inline-block;
    border: 0;
    padding: 10px;
    text-transform: uppercase;
    border-radius: 5px; */
    background-color: #f0ad4e;
    color: #fff;

    display: inline-block;
    /* padding: 6px 12px; */
    margin-bottom: 0;
    /* font-size: 14px; */
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    /* border-radius: 4px; */

    padding: 10px;
    border-radius: 5px;
}

  button.playground.done {
    background-color: #0b835b;
    color: #30ca97;
}

  :global(body.modal-open) {
    overflow: hidden;
  }

  :global(.btn-lg) {
      padding: 10px 16px;
      font-size: 18px;
      line-height: 1.3333333;
      border-radius: 6px;
  }

  :global(.btn-warning) {
      color: #fff;
      background-color: #f0ad4e;
      border-color: #eea236;
  }
  :global(.btn) {
      display: inline-block;
      padding: 6px 12px;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.42857143;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background-image: none;
      border: 1px solid transparent;
      border-radius: 4px;
  }  

  .btn-success {
      border: 1px solid rgb(72, 131, 92) !important;
      background-color: rgb(72, 131, 92) !important;
    }

    :global(.closeButton) {
      position: absolute;
      /* right: 10px; */
      right: -10px;
      /* top: 8px; */
      top: -13px;
      width: 24px;
      height: 24px;
      content: ' ';
      background-color: #333;  
      opacity: 0.6;
      transform: rotate(0deg);
      transition: transform 0.5s linear, opacity 0.5s linear;
      border-radius: 15px;
      -webkit-border-radius: 15px;
      -moz-border-radius: 15px;
    }
    :global(.closeButton:hover) {
      opacity: 1;
      transform: rotate(90deg);
    }
    :global(.closeButton:before, .closeButton:after) {
      position: absolute;
      left: 10px;
      top: 2px;
      content: ' ';
      height: 20px;
      width: 4px;
      background-color: #fff;
    }
    :global(.closeButton:before) {
      transform: rotate(45deg);
    }
    :global(.closeButton:after) {
      transform: rotate(-45deg);
    }  

    :global(.sketch) {
        /* border: 1px dashed #d3d3d3; */
        /* border: 2px dashed #ffffff; */
        /* border: 2px dashed #272822; */
        border: 2px dashed #52534c;
        outline: none;
    }    

    /* #all-sketch-container {
      overflow: hidden; 
      right: -1000px;
      opacity: 0;
      transition: right 0ms 400ms, opacity 400ms 0ms;      
    }

    #all-sketch-container .visible {
      right: 0px;
      opacity: 1;
      transition: right 0ms 0ms, opacity 600ms 0ms;
    }  */

    textarea.output { 
      width: 100%; 
      height: 300px; 
      font-family: 'Lucida Console', Monaco, monospace;
      font-size: 14px;
      z-index: 110;
    }

    .tabs {
      background-color: rgb(172, 172, 172);
      padding: 9px 10px 10px 0px;
      overflow-x: scroll;
      white-space: nowrap;
      /* padding-left: 0px; */
      /* Hide scrollbar for IE, Edge and Firefox */
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
      /* z-index: 100;  */
    }

    /* Hide scrollbar for Chrome, Safari and Opera */
    .tabs::-webkit-scrollbar {
      /* display: none; */
      background-color: #272822;      
      height: 1px;
      /* position: fixed;
      margin-top: -10px;      
      top: -10px; */
    }

    .tabs:hover::-webkit-scrollbar {
      display: inline-block;
      height: 1px;
      /* position: fixed;
      margin-top: -10px; */
      /* width: 1em; */
      /* scrollbar-width: inherit; */
    }    

    .tabs:hover::-webkit-scrollbar-thumb {
      background-color: rgb(255, 255, 255);
      /* outline: 1px solid slategrey; */
      height: 1px;
      /* position: fixed;
      margin-top: -10px;       */
    }    

    .tab {
      color: #4f504a;
      padding: 10px;
      font-size: 14px;
      /* display: inline-block; */
      cursor: pointer;      
    }

    .tab.active {
      color: white;
      /* background-color: rgb(73, 73, 73); */
      background-color: #272822;
      padding: 10px;
    }    

.monaco-with-files {
    display: block; /* Hidden by default */
    position: fixed;
    z-index: 100;
    /* padding-top: 100px;  */
    /* padding: 100px; */

    /* left: 100px;
    right: 100px;
    top: 50px;
    bottom: 50px; */

    /* width: 80%;  */
    /* height: 10%;  */
    /* Enable scroll if needed */
    /* overflow: auto;  */
    /* height: 100%; */
    /* overflow: hidden; */

    width: 90%;
    height: 85%;
    top: 5%;
    margin-top: 0;
    left: 5%;
    margin-left: 0;
    max-width: 100%;    
}    

  .___del_modal {
    display: block; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 2; /* Sit on top */
    padding-top: 100px; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; 
    /* overflow:  ; */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }
</style>

<!-- <div id="myModal" class="modal" on:click={closeEditor}> -->
<div id="myModal" class="modal" on:click={()=>{console.log('close!'); closeEditor()}}>
<div class="monaco-with-files">
    {#if fromAdmin}
      <div class="tabs">
        {#each files as file, i (file.name)}
          <!-- <span class="tab" class:active={currentFile && file.name == currentFile.name} on:click|preventDefault|stopPropagation={()=>{changeTab(file.name)}}>{file.name}</span> -->
          <span class="tab" class:active={file.active} on:click|preventDefault|stopPropagation={()=>{changeTab(file.name)}}>{file.name}</span>
          <!-- <span class="tab active">Main.java</span> -->
        {/each}
        <span class="tab" on:click|preventDefault|stopPropagation={addNewTab}>+</span>
      </div>
    {/if}

    <div id="container" on:click|preventDefault|stopPropagation={()=>{}}>
    </div>

<div id="checkCodeWidget">  
  <!-- <div id="checkCodePreview" style="position: relative; top: 15px; background-color: grey" hidden={checkCodehidden}> -->
  <!-- <div id="checkCodePreview" style="position: relative; top: 15px; background-color: grey"> -->
  <div id="checkCodePreview" style="position: absolute; top: {fromAdmin ? 45 : 15}px; right: 15px; background-color: grey" hidden={checkCodehidden}>
    <div style="position: absolute; right: 0px; top: 4px;">
        <button id="runCodeButton" class="playground"
          on:click|preventDefault|stopPropagation={runCodeButton}>
          {getRandomHappySmile()}ЗАПУСТИТЬ КОД
        </button>
        {#if fromAdmin}
          <br><br>
          <button class="playground"
              on:click|preventDefault|stopPropagation={checkCode}>
              🔔АДМИН: CHECK
          </button>
        {/if}   
    </div>
  </div>
  {#if checkCodehidden == 'hidden'}
    <!-- <div style="position: relative; top: 15px; background-color: grey"> -->
    <div style="position: absolute; top: {fromAdmin ? 45 : 15}px; right: 15px; background-color: grey">
      <div style="position: absolute; right: 0px; top: 4px;">
          <button class="playground done" disabled>
            ✅ Задача сдана
          </button>    
      </div>
    </div>  
  {/if}        
    <!-- <div id="all-runcode-container" style="position: relative; top: 15px;" hidden> -->
    <div id="all-runcode-container" style="position: absolute; top: {fromAdmin ? 45 : 15}px; right: 15px;" hidden transition:slide>
      <a on:click|preventDefault|stopPropagation={closeRunCodeButton} href="none" id="close-runcode-button" class="closeButton" hidden>&nbsp;</a>
      <div id="mouseCoords2" style="color: #999999; position: absolute; right: 3px; bottom: -73px;">
      </div>
      <div id="check-code-button" style="color: #999999; position: absolute; right: 3px; bottom: -40px; display: none">
        <button id="submit-runcode-to-teacher-button" class="playground" style="display:none"
            on:click|preventDefault|stopPropagation={checkCode}>
            🔔ОТПРАВИТЬ НА ПРОВЕРКУ
        </button>
      </div>
      <div id="runcode-container" style="width: 500px;">
        <textarea class="output" id="runCodeOutput" bind:value={runCodeOutputAll} on:keypress|preventDefault|stopPropagation={textAreaHandleKeyupSend} on:click|preventDefault|stopPropagation></textarea>      
        <div id="runCodeSendToConsoleButton" style="width: 100%; display: none">
          <button on:click|preventDefault|stopPropagation="{send}" style="float: right">Send</button>
          <div style="overflow: hidden; padding-right: .5em;">
            <input bind:value={consoleText} style="width: 100%;" on:keyup|preventDefault|stopPropagation={handleKeyupSend}>
          </div>
        </div>
      </div>
    </div>
</div>

</div>    
</div>

<div id="processingWidget">
  <div id="processingPreview" style="position: relative; top: 15px; background-color: grey" {hidden}>
    <div style="position: absolute; right: 0px; top: 4px;">
        <!-- <button id="run-sketch-button" class="btn btn-warning btn-lg" -->
        <button id="run-sketch-button" class="playground"
          on:click|preventDefault|stopPropagation={()=>{runSketchButton();}}>
          {getRandomHappySmile()}ЗАПУСТИТЬ КОД
        </button>
      <!-- <button id="close-sketch-button" class="btn btn-default btn-sm">x</button>&nbsp; -->
    </div>
  </div>
    <div id="all-sketch-container" style="position: relative; top: 15px;">
      <a on:click|preventDefault|stopPropagation={closeSketchButton} href="none" id="close-sketch-button" class="closeButton" hidden>&nbsp;</a>
      <div id="mouseCoords" style="color: #999999; position: absolute; right: 3px; bottom: -73px;">
      </div>
      <div id="submitSketchToTeacher" style="color: #999999; position: absolute; right: 3px; bottom: -40px;"  hidden={checkProcessingCodehidden}>
        <button id="submit-sketch-to-teacher-button" class="playground" style="display:none"
            on:click|preventDefault|stopPropagation={submitSketchToTeacher}>
            {getRandomHappySmile()}СДАТЬ КОД НА ПРОВЕРКУ
        </button>
      </div>
      <div id="sketch-container">             
      </div>
    </div>
</div>

<svelte:head>
  <script src="https://cdn.jsdelivr.net/processing.js/1.4.8/processing.min.js"></script>
</svelte:head>